"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MatchHistorySearchHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "Match History is a record of recent match suggestions that you've made for unmatched recording groups."),
    react_1.default.createElement("p", null, "Once a match has been approved it will appear in the recording details section of the work within your catalog.")));
exports.default = MatchHistorySearchHeader;
